export enum VerifyEmailLocalizationId {
    VerifyEmailTitle = "sign-in-verify-email.verify_email_title",
    Email = "sign-in-verify-email.email_label",
    ContinueButton = "sign-in-verify-email.continue_button",
    BackButton = "sign-in-verify-email.back_button",
    StepPicture = "sign-in-verify-email.step_picture",
}
